import CustomChip from '@app/components/atoms/CustomChip/CustomChip'
import Section from '@app/components/atoms/Section/Section'
import ImageSlider from '@app/components/ImageSlider'
import OptionMenu from '@app/components/OptionMenu'
import { formatNumber, formatPrice, toDateTime, toRemainingTime } from '@app/libs/format'
import theme from '@app/libs/theme'
import useRemember from '@app/libs/useRemember'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Chip from '@mui/material/Chip'
import Collapse from '@mui/material/Collapse'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

const TypographyCustom = styled(Typography)({
  wordBreak: 'break-word',
  alignContent: 'center',
})

const IconButtonCustom = styled(IconButton)((props) => ({
  transform: props['aria-expanded'] ? 'rotate(180deg)' : 'rotate(0deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}))

const VoucherDetail = ({ voucher }) => {
  const { t } = useTranslation()
  const now = new Date()
  const [anchorEl, setAnchorEl] = useState(null)
  const [dataCart, setDataCart] = useRemember('cartVoucher', [])
  const [dataItems, setDataItems] = useState([])
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const [allExpandedVoucher, setAllExpandedVoucher] = useRemember(`VoucherDetail:${voucher.id}`, {
    description: true,
    guide: true,
    condition: true,
    term: true,
  })

  const handleExpand = (attribute) => {
    setAllExpandedVoucher({ ...allExpandedVoucher, [attribute]: !allExpandedVoucher[attribute] })
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const queryClient = useQueryClient()
  const mutation = useMutation(() => {}, {
    onSuccess: () => {
      queryClient.invalidateQueries('listCartVoucher')
    },
  })

  //TODO: backend
  const handleDelete = (dataToSave, item) => {
    const IndexMerchant = dataToSave.findIndex((r) => r?.type === item?.type)
    if (-1 !== IndexMerchant) {
      const index = dataToSave[IndexMerchant]['data'].findIndex((r) => r?.id === item?.id)
      if (-1 !== index) {
        dataToSave[IndexMerchant]['data'].splice(index, 1)
        if (0 === dataToSave[IndexMerchant]['data'].length) {
          dataToSave.splice(IndexMerchant, 1)
          setDataCart(dataToSave)
        } else {
          setDataCart(dataToSave)
        }
      } else {
        dataToSave[IndexMerchant]['data'].push(item)
        setDataCart(dataToSave)
      }
    }
  }

  const handleAdd = (item) => {
    mutation.mutate()
    const dataToSave = [...dataCart]
    if (0 === dataCart.length || !dataCart.some((r) => r?.type === item?.type)) {
      dataToSave.push({
        type: item?.type,
        data: [item],
      })
      setDataCart(dataToSave)
    } else {
      handleDelete(dataToSave, item)
    }
  }

  const { enqueueSnackbar } = useSnackbar()

  const handleCheck = (item) => {
    if (0 === dataCart.length || !dataCart.some((r) => r?.data.some((d) => d.id === item.id))) {
      enqueueSnackbar(t('ALERT.ADD_CART'), {
        variant: 'success',
      })
    } else {
      enqueueSnackbar(t('ALERT.REMOVE_CART'), {
        variant: 'warning',
      })
    }
  }

  useEffect(() => {
    if (dataCart && 0 < dataCart.length) {
      let joinArr = []
      dataCart.map((r) => (r.data || []).map((i) => (joinArr = [...joinArr, i])))
      setDataItems(joinArr)
    } else {
      setDataItems([])
    }
  }, [dataCart])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <ImageSlider images={voucher.images} />
            </Grid>
            <Grid item xs={8}>
              <Grid container spacing={2}>
                <Grid item xs={11}>
                  <Typography variant="h4">{voucher.name}</Typography>
                </Grid>
                <Grid item justifyContent="flex-end" xs={1}>
                  <OptionMenu
                    anchorEl={anchorEl}
                    handleClick={handleClick}
                    handleClose={handleClose}
                    open={null !== anchorEl}
                  >
                    <MenuItem
                      sx={{
                        padding: '8px 5px !important',
                      }}
                      onClick={() => {
                        handleCheck(voucher)
                        handleAdd(voucher)
                      }}
                    >
                      {dataItems && dataItems.some((row) => row.id === voucher.id)
                        ? `${t('VOUCHER.REMOVE')}`
                        : `${t('VOUCHER.ADD')}`}{' '}
                    </MenuItem>
                  </OptionMenu>
                </Grid>

                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('VOUCHER.MERCHANT')}
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1">{voucher.merchant.name}</Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('VOUCHER.CATEGORIES')}
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  {voucher.categories.map((item, index) => (
                    <Chip key={index} label={item.name} mr={5} />
                  ))}
                </Grid>

                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('VOUCHER.PRICE')}
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  <Typography variant="body1">{formatPrice(voucher.price)}</Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('VOUCHER.AVAILABLE_CODE')}
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  <Typography variant="body1">{formatNumber(voucher.available_codes)}</Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('VOUCHER.EXPIRED_DATE')}
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  <Typography variant="body1">{toDateTime(voucher.expired_date)}</Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('VOUCHER.TYPE')}
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  <CustomChip color={voucher.type} label={t(`VOUCHER.${voucher.type.toUpperCase()}`)} />
                </Grid>

                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('VOUCHER.REMAIN_TIME')}
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  {toRemainingTime(now, voucher.expired_date)}
                </Grid>

                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('VOUCHER.STATUS')}
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  <CustomChip color={voucher.status} label={t(`VOUCHER.${voucher.status.toUpperCase()}`)} />
                </Grid>

                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('VOUCHER.HASHTAGS')}
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  {voucher.tags.length ? (
                    voucher.tags.map((item, index) => <Chip key={index} label={item.name} />)
                  ) : (
                    <Typography variant="body1">{t('VOUCHER.NOT_SET')}</Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('VOUCHER.DESCRIPTION')}{' '}
                <IconButtonCustom
                  aria-expanded={allExpandedVoucher.description}
                  aria-label="show more"
                  onClick={() => handleExpand('description')}
                >
                  <ExpandMore />
                </IconButtonCustom>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Collapse unmountOnExit in={allExpandedVoucher.description} timeout="auto">
                {voucher.description ? (
                  <TypographyCustom
                    dangerouslySetInnerHTML={{ __html: voucher.description }}
                    variant="body1"
                  ></TypographyCustom>
                ) : (
                  <Typography variant="body1">{t('VOUCHER.NOT_SET')}</Typography>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('VOUCHER.HOW_TO_USE')}{' '}
                <IconButtonCustom
                  aria-expanded={allExpandedVoucher.guide}
                  aria-label="show more"
                  onClick={() => handleExpand('guide')}
                >
                  <ExpandMore />
                </IconButtonCustom>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Collapse unmountOnExit in={allExpandedVoucher.guide} timeout="auto">
                {voucher.how_to_use ? (
                  <TypographyCustom
                    dangerouslySetInnerHTML={{ __html: voucher.how_to_use }}
                    variant="body1"
                  ></TypographyCustom>
                ) : (
                  <Typography variant="body1">{t('VOUCHER.NOT_SET')}</Typography>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('VOUCHER.TERM_AND_CONDITION')}{' '}
                <IconButtonCustom
                  aria-expanded={allExpandedVoucher.condition}
                  aria-label="show more"
                  onClick={() => handleExpand('condition')}
                >
                  <ExpandMore />
                </IconButtonCustom>
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Collapse unmountOnExit in={allExpandedVoucher.condition} timeout="auto">
                {voucher.condition ? (
                  <TypographyCustom
                    dangerouslySetInnerHTML={{ __html: voucher.condition }}
                    variant="body1"
                  ></TypographyCustom>
                ) : (
                  <Typography variant="body1">{t('VOUCHER.NOT_SET')}</Typography>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>
    </Grid>
  )
}

export default VoucherDetail
